import { DescriptionCard, Modal } from '@components';
import { useScreenSize } from '@hooks';
import { Button, Flex, Image, theme, Typography } from '@styles';
import { bool, func, number, shape, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RANK_DESCRIPTIONS_BY_NAME } from '../../constants/rankPoints';
import {
  calculateProgressBarWidth,
  getModalContainerProps,
} from './RankPointsModal.styles';

const RankPointsModal = ({
  isVisible,
  rank,
  rankCheckPoint,
  rankPoints,
  setModalVisible,
}) => {
  const {
    i18n: { language, t },
  } = useTranslation();
  const { isTabletSM } = useScreenSize();

  return (
    <Modal
      isVisible={isVisible}
      modalContainerProps={getModalContainerProps({ isTabletSM })}
      setModalVisible={setModalVisible}
      withBackdropNoise
    >
      <Flex
        color={theme.colors.white[100]}
        flexDirection="column"
        gap={8}
        p={40}
        width="100%"
      >
        <Flex alignItems="center" gap={8}>
          <Image src={rank?.image_small} />
          <Typography
            variant={isTabletSM ? 'MS-bold-s18-lh19' : 'MS-bold-s24-lh30'}
          >
            {rank?.name}
          </Typography>
        </Flex>
        <Typography variant="MS-regular-s14-lh22">
          {RANK_DESCRIPTIONS_BY_NAME[language][rank?.name]}
        </Typography>
        <Typography mt={16} variant="MS-regular-s12-lh13">
          {`${rankPoints}/${rankCheckPoint} `}
          {t('MainPage.PointsToNextRank').toUpperCase()}
        </Typography>
        <Flex border="3px solid rgb(255, 255, 255, 0.2)" width="100%">
          <Flex
            background={theme.colors.schoolBusYellow[100]}
            height="12px"
            m="2px"
            width={calculateProgressBarWidth({
              rankCheckPoint,
              rankPoints,
            })}
          />
        </Flex>
        <DescriptionCard
          containerProps={{ my: 16, p: 16 }}
          content={t('MainPage.RankDescription')}
          textVariant="MS-regular-s14-lh22"
        />
        <Button onClick={() => setModalVisible(false)} variant="secondary">
          <Typography variant="MS-regular-s16-lh25">
            {t('ActivityModal.Close')}
          </Typography>
        </Button>
      </Flex>
    </Modal>
  );
};

RankPointsModal.propTypes = {
  isVisible: bool.isRequired,
  rank: shape({
    image_large: string.isRequired,
    image_small: string.isRequired,
    name: string.isRequired,
  }).isRequired,
  rankCheckPoint: number.isRequired,
  rankPoints: number.isRequired,
  setModalVisible: func.isRequired,
};

export default RankPointsModal;
